import { render } from "./PostInvoices.vue?vue&type=template&id=9293b1ae"
import script from "./PostInvoices.vue?vue&type=script&lang=js"
export * from "./PostInvoices.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__